/**
 * TPR's checklist-display bucket outcomes for Step 8 (Bucket assignment) of the reviewer
 * sync-verification checklist. Distinct from `TprReferralProcessingStatus`, which is the *live
 * automated workflow's* internal-note vocabulary — these strings are the ops-facing bucket
 * codes from TPR's real-world routing decision tree and are shown to reviewers as-is.
 */
export enum TprSyncBucket {
  CLOSED = "closed",
  SS_CARDIO = "sscardio",
  BILTMORE_CARD_REFERRAL = "biltmorecardreferral",
  BILTMORE_CARD_IO_SCHED = "biltmorecardiosched",
  BILTMORE_COUMADIN = "biltmorecoumadin",
  PULMONARY_REFERRALS = "pulmonaryreferrals",
}
